export enum PaymentType {
  CASH = 'CASH',
  NON_CASH = 'NON_CASH',
  SWIFT = 'SWIFT',
  CRYPT = 'CRYPT',
}

export const PAYMENT_TYPES = [
  {
    name: 'Наличные',
    value: PaymentType.CASH,
  },
  {
    name: 'Безналичный',
    value: PaymentType.NON_CASH,
  },
];

export enum PaymentMethod {
  PRE_PAYMENT = 'PRE_PAYMENT',
  POST_PAYMENT = 'POST_PAYMENT',
}

export const PAYMENT_METHODS = [
  {
    name: 'Предоплата',
    value: PaymentMethod.PRE_PAYMENT,
  },
  {
    name: 'По факту',
    value: PaymentMethod.POST_PAYMENT,
  },
];
